import { useEffect } from "react";

export function useSuppressKeyboardZoom() {
  function zoomSuppress(e: KeyboardEvent) {
    const isMetaOrCtrlDown = e.metaKey || e.ctrlKey;
    if (
      (isMetaOrCtrlDown && e.key === "=") ||
      (isMetaOrCtrlDown && e.key === "+") ||
      (isMetaOrCtrlDown && e.key === "-") ||
      (isMetaOrCtrlDown && e.key === "_") 
    ) {
      e.preventDefault();
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", zoomSuppress);

    return () => document.removeEventListener("keydown", zoomSuppress);
  }, []);
}